"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDecryptedPayload = isDecryptedPayload;
exports.isEncryptedPayload = isEncryptedPayload;
exports.isDeletedPayload = isDeletedPayload;
exports.isErrorDecryptingPayload = isErrorDecryptingPayload;
const TransferPayload_1 = require("../../TransferPayload");
function isDecryptedPayload(payload) {
    return (0, TransferPayload_1.isDecryptedTransferPayload)(payload);
}
function isEncryptedPayload(payload) {
    return (0, TransferPayload_1.isEncryptedTransferPayload)(payload);
}
function isDeletedPayload(payload) {
    return (0, TransferPayload_1.isDeletedTransferPayload)(payload);
}
function isErrorDecryptingPayload(payload) {
    return (0, TransferPayload_1.isErrorDecryptingTransferPayload)(payload);
}
